export enum CampaignStatus {
  UNSET_CAMPAIGN_STATUS = 'UNSET_CAMPAIGN_STATUS', // Do not use, needed because of proto3 limitations
  ACTIVATED = 'ACTIVATED',
  PAUSED = 'PAUSED',
  DEFAULT = 'DEFAULT',
  SCHEDULED = 'SCHEDULED',
  TERMINATED = 'TERMINATED',
  EXPIRED = 'EXPIRED',
}
